import { percentageSignFilter } from "app/filters/ngFilters";
import combineConfigs from "pro-features/components/Chart/src/combineConfigs";
import noLegendConfig from "pro-features/components/Chart/src/configs/legend/noLegendConfig";
import yAxisLabelsConfig from "pro-features/components/Chart/src/configs/yAxis/yAxisLabelsConfig";
import noAnimationConfig from "pro-features/components/Chart/src/configs/animation/noAnimationConfig";
import { watermarkService } from "app/common/services/watermarkService";
import noTooltipConfig from "pro-features/components/Chart/src/configs/tooltip/noTooltipConfig";
import type { IChartData } from "../TrafficShareBarChart.types";
import type { IServices } from "../../common/useMarketingChannelsServices";

export const getChartConfig = (data: IChartData, services: IServices) => {
    const yAxisFormatter = ({ value }) => `${percentageSignFilter()(value, 0)}`;
    const recordNames = data.data.map((record) => services.translate(record.key));

    return combineConfigs({ yAxisFormatter }, [
        noLegendConfig,
        noTooltipConfig,
        yAxisLabelsConfig,
        noAnimationConfig,
        {
            chart: {
                height: 198,
                type: "column",
                spacingTop: 20,
                events: {
                    load: function () {
                        watermarkService.add.call(this, { opacity: 0.1 });
                    },
                },
            },
            plotOptions: {
                series: {
                    states: {
                        hover: {
                            enabled: false,
                        },
                    },
                },
                column: {
                    groupPadding: 0.45,
                    maxPointWidth: 48,
                    minPointLength: 3,
                    pointPadding: 0.1,
                    pointWidth: 80,
                    dataLabels: {
                        color: "#38536b",
                        crop: false,
                        enabled: true,
                        formatter() {
                            return `${percentageSignFilter()(this.y, 2)}`;
                        },
                        overflow: "none",
                        style: {
                            fontSize: "14px",
                            fontFamily: "Roboto",
                            fontWeight: "",
                        },
                    },
                },
            },
            yAxis: {
                gridLineWidth: 0.5,
                reversed: false,
                gridZIndex: 2,
                reversedStacks: true,
                min: 0,
                max: 1,
                startOnTick: false,
                endOnTick: true,
                showLastLabel: true,
                title: null,
                opposite: false,
                tickAmount: 3,
                labels: {
                    x: -10,
                    style: {
                        fontSize: "12px",
                        fontFamily: '"Roboto", sans-serif',
                    },
                },
            },
            xAxis: {
                gridLineWidth: 0,
                gridLineDashStyle: "dash",
                tickLength: 5,
                categories: recordNames,
                labels: {
                    style: {
                        textTransform: "capitalize",
                        fontSize: "14px",
                        color: "#556575",
                        fontFamily: '"Roboto", sans-serif',
                    },
                },
                minPadding: 0,
                maxPadding: 0,
            },
        },
    ]);
};
